"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshEnv = exports.getClientEnvVariable = exports["default"] = void 0;
var getClientEnvVariable = exports.getClientEnvVariable = function getClientEnvVariable(variableName) {
  if (typeof window !== 'undefined' && typeof window.__EMBEDDED_VARIABLES__ !== 'undefined') {
    return window.__EMBEDDED_VARIABLES__[variableName];
  }
  return process.env[variableName];
};
var env = {
  CONFIG: getClientEnvVariable('CONFIG'),
  BRANCH_IDENTIFIER: getClientEnvVariable('BRANCH_IDENTIFIER'),
  ASSEMBLY_VERSION: getClientEnvVariable('ASSEMBLY_VERSION'),
  BOUNDED_CONTEXT_APP_NAME: getClientEnvVariable('BOUNDED_CONTEXT_APP_NAME'),
  FORCE_NEW_RELIC_BROWSER_SCRIPT_FALLBACK: getClientEnvVariable('FORCE_NEW_RELIC_BROWSER_SCRIPT_FALLBACK'),
  PARTY_TOWN_PROXY_DOMAIN: getClientEnvVariable('PARTY_TOWN_PROXY_DOMAIN'),
  PARTY_TOWN_LIB: getClientEnvVariable('PARTY_TOWN_LIB'),
  PARTY_TOWN_DEBUG: getClientEnvVariable('PARTY_TOWN_DEBUG')
};
var refreshEnv = exports.refreshEnv = function refreshEnv() {
  env.CONFIG = getClientEnvVariable('CONFIG'), env.BRANCH_IDENTIFIER = getClientEnvVariable('BRANCH_IDENTIFIER'), env.ASSEMBLY_VERSION = getClientEnvVariable('ASSEMBLY_VERSION'), env.BOUNDED_CONTEXT_APP_NAME = getClientEnvVariable('BOUNDED_CONTEXT_APP_NAME'), env.FORCE_NEW_RELIC_BROWSER_SCRIPT_FALLBACK = getClientEnvVariable('FORCE_NEW_RELIC_BROWSER_SCRIPT_FALLBACK'), env.PARTY_TOWN_PROXY_DOMAIN = getClientEnvVariable('PARTY_TOWN_PROXY_DOMAIN'), env.PARTY_TOWN_LIB = getClientEnvVariable('PARTY_TOWN_LIB'), env.PARTY_TOWN_DEBUG = getClientEnvVariable('PARTY_TOWN_DEBUG');
};
var _default = exports["default"] = env;